export default __webpack_public_path__ + "static/media/english-to-finnish-screenshot-02.337e31c9.png";